import { createFileRoute } from "@tanstack/react-router";
import { SigningPage } from "@/features/signing/SigningPage";

/** Public signing page for one agreement. Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/p/sign/$token")({
  component: SigningRoute,
});

function SigningRoute() {
  const { token } = Route.useParams();
  return <SigningPage token={token} />;
}
